@file:OptIn(InternalResourceApi::class)

package mobile_wallet.core.ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringArrayResource

private const val MD: String = "composeResources/mobile_wallet.core.ui.generated.resources/"

public val Res.array.core_ui_password_strength_labels: StringArrayResource by lazy {
      StringArrayResource("string-array:core_ui_password_strength_labels", "core_ui_password_strength_labels", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 108),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainArray0Resources(map: MutableMap<String, StringArrayResource>) {
  map.put("core_ui_password_strength_labels", Res.array.core_ui_password_strength_labels)
}
